var exports = {
  "kL": "ChannelPermissionsTab.module__container___UnVWSW",
  "Ut": "ChannelPermissionsTab.module__syncBanner___UnVWSW",
  "iH": "ChannelPermissionsTab.module__syncBannerSynced___UnVWSW",
  "bT": "ChannelPermissionsTab.module__syncBannerUnsynced___UnVWSW",
  "Vg": "ChannelPermissionsTab.module__grid___UnVWSW",
  "s4": "ChannelPermissionsTab.module__leftTitle___UnVWSW",
  "pG": "ChannelPermissionsTab.module__right___UnVWSW",
  "ze": "ChannelPermissionsTab.module__rightScroller___UnVWSW",
  "CI": "ChannelPermissionsTab.module__sectionRow___UnVWSW",
  "bV": "ChannelPermissionsTab.module__sectionHeader___UnVWSW",
  "Gf": "ChannelPermissionsTab.module__sectionTitle___UnVWSW",
  "bQ": "ChannelPermissionsTab.module__subtleText___UnVWSW",
  "cy": "ChannelPermissionsTab.module__permHeaderRow___UnVWSW",
  "mA": "ChannelPermissionsTab.module__permHelp___UnVWSW",
  "p$": "ChannelPermissionsTab.module__emptyState___UnVWSW",
  "rV": "ChannelPermissionsTab.module__overwriteItem___UnVWSW",
  "w7": "ChannelPermissionsTab.module__overwriteItemSelected___UnVWSW",
  "Vd": "ChannelPermissionsTab.module__overwriteItemContextMenuOpen___UnVWSW",
  "FD": "ChannelPermissionsTab.module__overwriteIcon___UnVWSW",
  "m4": "ChannelPermissionsTab.module__roleDot___UnVWSW",
  "l": "ChannelPermissionsTab.module__overwriteName___UnVWSW",
  "Fs": "ChannelPermissionsTab.module__permSearchRow___UnVWSW",
  "XZ": "ChannelPermissionsTab.module__permSearchInput___UnVWSW",
  "sN": "ChannelPermissionsTab.module__layoutButtons___UnVWSW",
  "Zh": "ChannelPermissionsTab.module__layoutButton___UnVWSW",
  "HU": "ChannelPermissionsTab.module__permCategories___UnVWSW",
  "Fv": "ChannelPermissionsTab.module__mobileOverrideList___UnVWSW",
  "E_": "ChannelPermissionsTab.module__mobileListHeader___UnVWSW",
  "JJ": "ChannelPermissionsTab.module__mobileListTitle___UnVWSW",
  "_4": "ChannelPermissionsTab.module__mobileOverrides___UnVWSW",
  "Ud": "ChannelPermissionsTab.module__mobileOverrideItem___UnVWSW",
  "wP": "ChannelPermissionsTab.module__mobileOverrideName___UnVWSW",
  "wu": "ChannelPermissionsTab.module__mobileOverrideChevron___UnVWSW",
  "yg": "ChannelPermissionsTab.module__mobileBackRow___UnVWSW",
};

module.exports = exports;
